const AllRemedyInfo = [

        

  [
    {
        remedyName:'ACONITE',
        physical:'שיעול יבש, קצר, נובע מגירוי בגרון, מוחמר בשתייה, אכילה, תנוחה זקופה, מלווה בהרבה חוסר שקט.',
        emotional:'חוסר שקט בעיקר בלילה, לא מסוגל לישון',
        unique:'כתוצאה מקור יבש כמו מזגן או רוחות יבשות. הכל פתאומי, מהיר ועוצמתי. תחילת מחלה.',
        id:1
    },
    {
        remedyName:'Antimonium tartaricum',
        physical:'רעשים של חרחור ליחה מרובה בכל נשימה, שלא יוצאת החוצה בשיעול. שיעול עוצמתי שמסתיים לעיתים בהקאה. התקפי שיעול חונקים. מוטב בתנוחה זקופה, בהוצאת ליחה. החמרה לאחר חצות הלילה ומחום המיטה.',
        emotional:'עייף, מתוסכל ועצבני. לא רוצה להיות לבד, אבל גם לא רוצה שיתקרבו אליו.',
        unique:'הצטברות אדירה של ליחה בחזה, צמיגית וצהובה, שאינה יוצאת ומייצרת המון רעש בנשימה.',
        id:2
    },
    {
        remedyName:'Belladona',
        physical:'שיעול חזק ועוויתי, התקפים של שיעול. תחושה שמשהו מפריע בגרון ומגרה לשיעול כל הזמן. שיעול מוביל לכאב ראש, כאב בחזה.',
        emotional:'עצבני וחסר שקט, ילד יכול להיות תוקפני ולנשוך. עם זאת יש מקרים של מצב אפאטי פתאומי.',
        unique:'שיעול מוחמר בלילה במיטה – מעיר משינה. ראש חם ופנים מאוד אדומות. התקף שיעול',
        id:3
    },
    {
        remedyName:'Drosera',
        physical:'שיעול עוויתי, נבחני, עם קול עמוק וצרוד. מרגיש כאילו החלק התחתון בבטן , עומד להתפוצץ ומחזיק אותו בידיים בזמן שיעול. התקפי שיעול המגיעים אחד אחרי השני עם הפסקות קטנות. נחנקים ובקושי מצליחים לנשום בין שיעולים(דומה להתקף שעלת)',
        emotional:'חוסר מנוחה ועצבנות, קושי להתרכז. מלא פחדים וחששות, בעיקר כאשר נמצא לבד',
        unique:'שיעול מתפרץ ברגע שהראש נוגע בכרית במצב שכיבה. כל גירוי של קנה הנשימה עם דיבור, צחוק, אכילה ושתייה, מעורר התקף שיעול',
        id:4
    },
    {
        remedyName:'Ipecacuanha',
        physical:'שיעול עוויתי – אסטמתי, הגוף רועד, הזעה במצח. קושי לנשום, רעשים של חרחור, העור מקבל גוון כחלחל. שיעול עד מצב של הקאה',
        emotional:'התנהגות קפריזית ועצבנית, מבקש הרבה דברים אבל לא בטוח מה הוא רוצה.',
        unique:'תחושה חזקה של בחילה, ושיעול שמגיע להקאות. תחושה בחילה באזור החזה.'
        ,id:5
    },
    {
        remedyName:'Spongia',
        physical:'שיעול מאוד יבש, שרקני, נבחני. כל מערכת הנשימה מרגישה מאוד יבשה. אין בכלל ליחה.',
        emotional:'תשישות, עקשנות ועצבנות. התקפי חרדה שהוא הולך להיחנק או למות',
        unique:'נשמע כמו מסור ידני, המנסר גזע עץ'
        ,id:6
    }
    ],
    
    
    
     [
        {
            remedyName:'NUX-VOMICA',
            physical:'בתחילת המחלה, אף סתום, תחושת כובד במצח. אף נוזל בבוקר וסתום בשאר היום.',
            emotional:'עצבני וחסר סבלנות, קר לו וחושש מפרצי רוח',
            unique:'תחושת קור, ענייני בטן(בחילות ויציאות מרובות). תחושת יובש, אבל אין צמא'
            ,id:1
        },
        {
            remedyName:'ACONITE',
            physical:'הופעה פתאומית של כאב ראש חזק, חום גבוה, כאבי שרירים, התעטשויות תכופות ונזלת שקופה',
            emotional:'חוסר שקט בעיקר בלילה, לא מסוגל לישון',
            unique:'כתוצאה מקור יבש כמו מזגן או רוחות יבשות. הכל פתאומי, מהיר ועוצמתי.'
            ,id:2
        },
        {
            remedyName:'ALLIUM CEPA',
            physical:'נזלת מרובה ועיניים דומעות, מתעטשים בלי הפסקה. נזלת צורבת והאף והשפה העליונה אדומים ופצועים.',
            emotional:'תשוש ועצבני מהתעטשויות בלתי פוסקות',
            unique:'חם לו והוא צמא, מרגיש טוב יותר באוויר הפתוח'
            ,id:3
        },
        {
            remedyName:'ARSENICUM',
            physical:'האף סתום, ועם זאת כל הזמן זרימה עדינה של נזלת שקופה. נזלת צורבת את השפה.',
            emotional:'מאוד חסר שקט, חרדתי ולא רוצה להיות לבד, אבל נוכחות אנשים מעצבנת אותו',
            unique:'תחושת קור פנימי כה חזק שמרגיש כאילו שורף. יכול להיות גם בחילות, הקאות ושלשולים'
            ,id:4
        },
        {
            remedyName:'BRYONIA',
            physical:'מתחיל בנזלת מהאף ודמע בעיניים שבמהרה עוברים לגרון וגורמים לצרידות, גם לריאות ושיעול חזק',
            emotional:'עצבני, רוצה לשכב ולא לזוז, שיעזבו אותו בשקט',
            unique:'תחושת יובש חזקה עם צמא גדול, מרגיש שהראש עומד להתפוצץ'
            ,id:5
        },
        {
            remedyName:'HEP-SULPH ',
            physical:'התעטשויות ונזלת שהופכת משקופה לצהובה, לעיתים מאוד מסריחה. שיעול עם ליחה פנימית. קר לו ומזיע כל הלילה ללא הקלה.',
            emotional:'מאוד רגיש לכל מגע, עצבני עד פרצי זעם',
            unique:'גרון מוגלתי ונזלת מוגלתית'
            ,id:6
        },
        {
            remedyName:'KALI-BICH',
            physical:'נזלת וליחה צמיגית, תקוע בגרון ותקוע באף. יוצאת רק בגושים צמיגיים.',
            emotional:'קושי עם שינויים, צורך לשמור על שגרה ברורה וקבועה',
            unique:'מצבים של סינוסיטיס, הפרשות צהובות וירוקות'
            ,id:7
        },
        {
            remedyName:'PULS',
            physical:'נזלת צהובה ירוקה, זורמת בקלות, דמעות זורמות בקלות',
            emotional:'התנהגות תלותית ובכיינית',
            unique:'ההפרשות צהובות ירוקות, יכול גם להופיע בעיניים'
            ,id:8
        }
        ],
    
    
    [
        {
            remedyName:'ARNICA',
            physical:'הראשונה במקרה של חבלה, לטיפול בכל חבלה ברקמות הרכות. טיפול ראשוני גם בנקעים והתכווצויות שרירים.',
            emotional:'הפצוע יטען שהוא בסדר ולא צריך עזרה, שהכל בסדר ולא רוצה שיתקרבו אליו',
            unique:'מחריף בעת מגע, ומשתפר בהנחת רטיות קרות. מורידה את הכאב ואת הנפיחות',
            id:1
        },
        {
            remedyName:'BELLIS PERENIS',
            physical:'פגיעה ברקמות רכות עמוקות ופנימיות, במיוחד באזור הבטן והחזה. (כמו arnica פנימית). ',
            emotional:'עקשנות, עצבנות ובלבול',
            unique:'במידה ואין שיפור עם arnica, היא תאפשר שיפור נוסף. הטבה בתנועה ועיסוי של המקום. מגע ורטיות קרות מחריפות.',
            id:2
        },
        {
            remedyName:'HAMAMELLIS',
            physical:'כאשר יש כאב עז, מקרים של פגיעה בוורידים.',
            emotional:'פגיעה בזיכרון, חוסר רצון לביצוע מאמץ מנטאלי, עצבני',
            unique:'דימום רב – המטומה גדולה',
            id:3
        },
        {
            remedyName:'HYPERICUM',
            physical:"פגיעה עצבית, פגיעה במרכזי עצבים, דלקות עצבים. מעיכה של מרכזי עצבים(אצבעות, לשון וכו'...)",
            emotional:'תחושת בלבול, טעויות בכתיבה, מתענה מהכאבים העצביים',
            unique:'כאב מקרין, פגיעה חזקה במרכז עצבי',
            id:4
        },
        {
            remedyName:'LEDUM',
            physical:'חבורות כתוצאה מפצעי דקירה, נקעים, התכווצויות שרירים. שטפי דם בצבע סגול כהה',
            emotional:'סלידה מחברה, מתרחק מאנשים ומתנהג בצורה לא נעימה כדי שיעזבו אותו בשקט',
            unique:'פצעי דקירה עם סימן סגול כהה, משתפר עם רטיות קרות, קר למגע בתחושה'
            ,id:5
        },
        {
            remedyName:'RUTA',
            physical:'פגיעות בעצם ובקרום העצם, פגיעות בסחוס ובמפרקים.',
            emotional:'ביקורתי ולא מרוצה משום דבר, נרתע מכל מגע ',
            unique:'פגיעה בעצם גידים וסחוסים'
            ,id:6
        },
        {
            remedyName:'SYMPHYTUM',
            physical:'פגיעות בעין לאחר פגיעה מחפץ כהה. פגיעה בעצם במידה ואין שיפור עם ruta.',
            emotional:'עצבות ועצבנות, מכונס בעצמו',
            unique:'פגיעה בארובת העין'
            ,id:7
        }
        ],
    
    
         [
            {
                remedyName:'ACONITE',
                physical:'שלב ראשוני ופתאומי, תחושת חום בהטלת שתן ',
                emotional:'פחד גדול , חרדה, חוסר מנוחה. ',
                unique:'הופעה מהירה ופתאומית של דלקת בשתן',
                id:1
            },
            {
                remedyName:'APIS',
                physical:'כאב חד ודוקר בעת הטלת שתן',
                emotional:'חוסר מנוחה ועצבנות',
                unique:'חד ודוקר',
                id:2
            },
            {
                remedyName:'BELLADONNA',
                physical:'צורך תכוף למתן שתן ותחושת צריבה. מתפתח חום עם פנים אדומות וסמוקות',
                emotional:'עצבני כשאנשים נגשים אליו, רצון לברוח, רגישות של כל החושים',
                unique:'חום גבוה, פנים סמוקות, ידיים ורגליים קרות. אישונים מורחבים. התכווצויות של שלפוחית השתן',
                id:3
            },
            {
                remedyName:'CANTHARIS',
                physical:'צריבה וכאב חד, דחף חזק להטיל שתן עם כמות שתן קטנה מאוד. התכווצויות בגב תחתון ובטן',
                emotional:'תחושת מצוקה פנימית, חוסר סובלנות ועצבנות לסביבה',
                unique:'הטובה ביותר במקרה של כאבים חזקים וצורבים',
                id:4
            },
            {
                remedyName:'MERCURIUS',
                physical:'במקרים של דם ומוגלה בשתן, כאבים עזים וצורבים.',
                emotional:'חוסר החלטיות, משנה את דעתו בקביעות, זיכרון חלש, חוסר בטחון עצמי.',
                unique:'הפרשות מוגלתיות ודמיות'
                ,id:5
            },
            {
                remedyName:'STAPHISAGRIA ',
                physical:'כאבים צורבים, עוצמה בינונית של דלקת ',
                emotional:'רגישות מוגברת, נפגע ונעלב בקלות',
                unique:'במיוחד בדלקת אחרי יחסי מין או שימוש בקטטר'
                ,id:6
            }
            ],
    
             [
                {
                    remedyName:'ACONITE',
                    physical:'שלב ראשוני ומהיר, עם חום גבוה, צמא, הגרון אדום כהה, תחושת גרד וכיווץ של הגרון. שיעול יבש עם קול נבחני וצרוד כתוצאה מעיוות הגרון.',
                    emotional:'פחד גדול , חרדה, חוסר מנוחה. ',
                    unique:'הופעה מהירה ופתאומית של כאב גרון, ללא מוגלה, תוצאה של רוח קרה ויבשה',
                    id:1
                },
                {
                    remedyName:'APIS',
                    physical:'מראה מאוד אדום, נפוח ובצקתי. הגרון נראה מודלק ונוצץ. ענבל מאוד נפוח. כאבים עוקצים ובוערים, מקרינים לאוזניים',
                    emotional:'חוסר מנוחה ועצבנות',
                    unique:'שקדים וענבל מאוד נפוחים, אדומים ונוצצים. הכל בצקתי.',
                    id:2
                },
                {
                    remedyName:'BELLADONNA',
                    physical:'חום גבוה, גרון מאוד אדום, יובש בפה ובגרון. לא מסוגל לשתות עקב הכאב העז.',
                    emotional:'עצבני כשאנשים נגשים אליו, רצון לברוח, רגישות של כל החושים',
                    unique:'חום גבוה, פנים סמוקות, ידיים ורגליים קרות. אישונים מורחבים',
                    id:3
                },
                {
                    remedyName:'HEPAR SULPH',
                    physical:'כאבים דוקרים, מקרינים לאוזניים, תחושה של גרון משופשף ופצוע. מוגלה, כיבים ואבצסים. תחושת קור בגרון',
                    emotional:'הרבה עצבנות וכעס, תגובות אלימות',
                    unique:'דלקת חריפה מתקדמת, הפרשת מוגלה, כאבים חדים כאילו יש קיסם בגרון',
                    id:4
                },
                {
                    remedyName:'LACHESIS',
                    physical:'גרון מנומר בגווני כחול, כחול- אדום, סגול, בלוטות צוואריות נפוחות ומפרישות מוגלה.  רוק וריר רבים, לשון נפוחה, קשה, רועדת.',
                    emotional:'דברנות גדולה, קינאה, חשדנות, פחד ללכת לישון.',
                    unique:'גרון מנומר בצבעים שונים, כאבים מוחמרים משתייה חמה ומוטבים משתייה קרה'
                    ,id:5
                },
                {
                    remedyName:'MERCURIUS',
                    physical:'כאב רב, תחושה של בשר חשוף, בעירה ודקירות באוזן בבליעה. בולע כל הזמן עקב רוק שופע ועדיין הגרון מרגיש יבש.  נפיחות של בלוטות מצידי האוזניים והבלוטות הצוואריות. לשון לחה, מחופה, צהובה',
                    emotional:'חוסר החלטיות, משנה את דעתו בקביעות, זיכרון חלש, חוסר בטחון עצמי.',
                    unique:'שקדים אדומים כהים או אדומים ירוקים עם כיבים. ריור מרובה.'
                    ,id:6
                }
                ], 
                
                
                 [
                    {
                        remedyName:'ACONITE',
                        physical:'לשימוש מיד לאחר האירוע, מנטרל את ההלם הרגשי והעצבי. פנים אדומות',
                        emotional:'מצב של הלם עצבי ורגשי',
                        unique:'ראשונה בשימוש, לטיפול בהלם',
                        id:1
                    },
                    {
                        remedyName:'Arsenicum',
                        physical:'כוויות עמוקות, שלפוחיות. האזור נפוח ומודלק, כאבים שורפים.',
                        emotional:'מאוד חסר שקט, חרדתי ולא רוצה להיות לבד, אבל נוכחות אנשים מעצבנת אותו. פחד ממוות',
                        unique:'זיהום כתוצאה מרקמות מתות שנותרו בתוך הפצע. לעיתים עוויתות בטן כתוצאה מהכוויות.',
                        id:2
                    },
                    {
                        remedyName:'Calendula',
                        physical:'כוויות יחסית קלות, דרגה 1, או לשימוש לאחר תרופה אחרת שכבר טיפלה במצב האקוטי הראשוני',
                        emotional:'מאוד עצבני, רגישות לרעש, נבהלים בקלות',
                        unique:"מקדם ריפוי ומונע צלקות. מומלץ לשימוש משולב פנימי וחיצוני עם משחה/ג'ל",
                        id:3
                    },
                    {
                        remedyName:'Cantharis',
                        physical:'התרופה ההומאופתית הנפוצה ביותר לכוויות חמורות, סוג 2-3. בשימוש מוקדם יכולה למנוע היווצרות שלפוחיות.',
                        emotional:'חוסר שקט אדיר, חשק מיני גבוה, הרבה עשייה חסרת תוכלת',
                        unique:'הטבה ממים קרים, החמרה כללית במגע והטבה במנוחה',
                        id:4
                    },
                    {
                        remedyName:'causticum',
                        physical:'כוויות כתוצאה מחשיפה לחומרים כימיים בעיקר, כוויות חמורות. יעילה לקידום הריפוי בכוויות ישנות של נרפאו לחלוטין',
                        emotional:'בכיינות, חרדה, רגישות ואמפתיה מוגברים לסביבה, פסימי',
                        unique:'כוויות כימיות או כוויות של נרפאו'
                        ,id:5
                    },
                    {
                        remedyName:'hypericum',
                        physical:'כוויות חמורות הגורמות לפגיעה עצבית',
                        emotional:'תחושת בלבול, טעויות בכתיבה, מתענה מהכאבים העצביים',
                        unique:'אובדן תחושה או כאב מקרין'
                        ,id:6
                    }
                    ],    
    
    
                     [
                        {
                            remedyName:'ACONITE',
                            physical:'הרעה מהירדמות בשמש. חום בוער, במיוחד הראש והפנים, עם יובש גדול בעור וצמא גדול. אודם בעיניים ובלחיים. בחילה ,סחרחורת, כאב ראש.',
                            emotional:'חרדה חסרת מנוחה, פחד מוות',
                            unique:'מכת שמש שבאה פתאום בעוצמה רבה',
                            id:1
                        },
                        {
                            remedyName:'Belladona',
                            physical:'כאב ראש, תחושת מלאות בראש, תחושה כאילו הכל נובע מן המצח. הרעה מכיפוף, תזוזה, או ע"י התנועה הקלה ביותר.',
                            emotional:'ייסורים וחוסר מנוחה גדולים. רוגז גדול של עצבי המוח. זעם, אימה, נטייה לתנועות עוויתיות, חרד מדברים מסביבו ולידו. נטייה לבכות ולצרוח.',
                            unique:'הראש פועם והולם, הרעה מאור, רעש. פנים אדומות, סמוקות אבל יתר הגוף קר.',
                            id:2
                        },
                        {
                            remedyName:'GLONOINUM',
                            physical:'כאב ראש הולם, בוער, פועם עם דם גועש כלפי הראש והלב. זעזוע בראש ובדופק. צמא.',
                            emotional:'בלבול כתוצאה מגודש דם לראש',
                            unique:"איבוד הכרה בא לאחר סחרחורת, בחילה, כאב ראש אלים, פנים וגוף סמוקים ואדומים.",
                            id:3
                        },
                        {
                            remedyName:'LACHESIS',
                            physical:'תוצאת מכת שמש שנמשכת באופן כרוני. דפיקות לב, תחושה שהלב מתכווץ, לא יכול לסבול לחץ כלשהו, דופק משתנה.',
                            emotional:'דברנות, מרגיש אימה, זיכרון חלש. כיווץ בגרון, קושי לבלוע, לא יכול לסבול מגע בצוואר.',
                            unique:'כאב ראש חמור. חמור יותר בצד שמאל. בגוד צמוד. צמרמורות וחולשה אחרי חשיפה לחום השמש. רגליים קרות.',
                            id:4
                        },
                        {
                            remedyName:'NATRUM CARB',
                            physical:'חוסר יכולת לחשוב, הראש מרגיש מעורפל וכואב בשמש. מסנוור מנצנוץ או נקודות שחורות סביב לעין, אפלוליות בראייה, דפיקות לב, רעד של הידיים, חולשה ממאמץ קל. חוסר מנוחה, שינה לא מרעננת, הזעה שופעת מכל מאמץ',
                            emotional:'בלבול, סחרחורת, כבדות, ערפול בראש.',
                            unique:'לא בסדר מאז מכת השמש, תוצאות כרוניות'
                            ,id:5
                        },
                        {
                            remedyName:'VERATRUM ALBUM',
                            physical:'זיעה  קרה על המצח, כאב ראש עם בחילה, הקאה, שלשולים ופנים חיוורים. צוואר חלש מידי בכדי להחזיק את הראש.',
                            emotional:'היפראקטיביות, חוסר שקט. מצב רוח ירוד ואדישות',
                            unique:'מצב של התמוטטות ושוק'
                            ,id:6
                        }
                        ],  
                        
                
                         [
                            {
                                remedyName:'ARSENICUM',
                                physical:'מתחילה בצואה מימית, ריח רע מאוד, תשישות עם חוסר שקט .בחילות והקאות. יציאות צורבות. יציאה יכולה להפוך לדמית.',
                                emotional:'מאוד חסר שקט, חרדתי ולא רוצה להיות לבד, אבל נוכחות אנשים מעצבנת אותו',
                                unique:'צמא חזק ולא מסוגל לשתות. תחושת צריבה ברקטום, שלשול צורב. רעד ותשישות גדולה.',
                                id:1
                            },
                            {
                                remedyName:'CHINA',
                                physical:'לרוב הרעלת מזון כתוצאה מדגים, שלשול לא כואב של מזון חצי מעוכל. מצב מחמיר אחרי שאוכלים.',
                                emotional:'אפאתיות ועצבות, מבואס על החיים',
                                unique:'תשישות מאוד חזקה בסיום התקף של שלשולים והקאות – אובדן נוזלים',
                                id:2
                            },
                            {
                                remedyName:'CARBO VEGETABILIS',
                                physical:'בעיקר כתוצאה מאוכל שומני ומקולקל. הרבה גזים ותחושה חזקה של נפיחות, גיהוקים.  הרבה רעש בבטן',
                                emotional:'מצב מתחלף בין תשישות ואפאטיות לעצבנות מכל דבר',
                                unique:"הטבה באוויר פתוח – משב רוח על הפנים למרות שקר לו. דופק בקושי מורגש, תשוש לגמרי גם אם לא היה אובדן נוזלים גדול. מלא גזים.",
                                id:3
                            },
                            {
                                remedyName:'IPECACUANHA',
                                physical:'כל הזמן בחילות, מקיא הרבה ואין הטבה מהקאה. כאבים עוויתיים חזקים באזור הבטן. לעיתים מלווה בריור רב. פנים מתעוותות מרוב כאב.',
                                emotional:'התנהגות קפריזית ועצבנית, מבקש הרבה דברים אבל לא בטוח מה הוא רוצה.',
                                unique:'הקאה מרובה ללא הטבה בתחושת הבחילה אחרי הקאה',
                                id:4
                            },
                            {
                                remedyName:'NUX VOMICA',
                                physical:'צואה של חלקים קטנים וריריים, לעיתים דמי, דחף חזק לצואה אבל עם קצת עצירות. הרבה מקרים של מזון עשיר בשומן וכבד לעיכול. ',
                                emotional:'עצבני וחסר סבלנות, קר לו וחושש מפרצי רוח. דואג בענייני עבודה',
                                unique:'שלשול מתחלף עם עצירות, מלווה בכאבי גב.'
                                ,id:5
                            },
                            {
                                remedyName:'PODOPHYLLUM',
                                physical:'שלשול מתפרץ ומתפזר, גזים חזקים עם שלשול. שלשול ליחתי. לעיתים מצב של דלקת במעי. לרוב בלי הקאות',
                                emotional:'המון דברנות ותלונות, אומר שהולך למות, נאנח מתוך שינה',
                                unique:'שלשול מתפרץ על כל האסלה, לעיתים בורח במכנסיים.'
                                ,id:6
                            },
                            {
                                remedyName:'VERATRUM ALBUM',
                                physical:'שלשול מימי ומתפרץ, מלווה גם בהקאות קשות, התכווצויות חזקות בבטן.',
                                emotional:'מלנכוליה ואדישות מתחלף עם התקפים של טירוף והתלהבות',
                                unique:'קר לאדם מאוד, תשוש וקופא. נראה גמור'
                                ,id:6
                            }
                            ],
                            
                            
                             [
                                {
                                    remedyName:'arnica',
                                    physical:'פצע יותר מסוג חבורה מאשר פצע פתוח. יש קצת חתכים קטנים, שריטות.',
                                    emotional:'הפצוע יטען שהוא בסדר ולא צריך עזרה, שהכל בסדר ולא רוצה שיתקרבו אליו',
                                    unique:'מונע שוק פיזי ונפשי, זיהום, כאב',
                                    id:1
                                },
                                {
                                    remedyName:'calendula',
                                    physical:'חתכים ושסעים עמוקים, קרעים בעור עם דימום ויציאה של נוזל מהפצע',
                                    emotional:'נטייה לעוויתות ועצבנות',
                                    unique:'הטובה ביותר למניעת זיהום וקידום החלמה',
                                    id:2
                                },
                                {
                                    remedyName:'Hypericum',
                                    physical:'פציעות וחתכים עם קרע גדול ומכוער, כאב מאוד חזק ומקרין לאזורים אחרים. מתאים גם לחדירות של קוצים ושבבים, כאשר הכאב נע לאורך העצב.',
                                    emotional:'תחושת בלבול, טעויות בכתיבה, מתענה מהכאבים העצביים',
                                    unique:"כאב מקרין, בעיקר באזור עשיר בעצבים. כאב חד ומפלח",
                                    id:3
                                },
                                {
                                    remedyName:'ledum',
                                    physical:'דימום מפצעי דקירה, נקבים, האזור מרגיש קר למגע וקר בתחושה של הפצוע. טוב למניעת טטנוס.',
                                    emotional:'סלידה מחברה, מתרחק מאנשים ומתנהג באופן לא נעים לאנשים',
                                    unique:'פצעי דקירה עם סימן סגול כהה, משתפר עם רטיות קרות, למרות שקר למגע בתחושה',
                                    id:4
                                },
                                {
                                    remedyName:'phosphorus',
                                    physical:'חתכים עם הרבה מאוד דימום, שכל הזמן נפתחים.',
                                    emotional:'סימפתטי וחביב, רגיש וקצת מפוחד',
                                    unique:'הרבה דימום'
                                    ,id:5
                                },
                                {
                                    remedyName:'Staphisagria',
                                    physical:'חתכים נקיים וישרים, תוצאה של פציעות מסכין, או חפץ חד אחר.',
                                    emotional:'רגישות ופגיעות, מתאפק להגיב ואז מתפרץ',
                                    unique:'מעולה להחלמת חתכים אחרי ניתוח'
                                    ,id:6
                                },
                                {
                                    remedyName:'Silica',
                                    physical:"חדירה של גוף זר – מחטים, שבבים וכו'. התרופה ההומאופתית תגרום לגוף לדחות את החלק הזר החוצה ללא תהליך מוגלתי. במידה וכבר יש מוגלה מימית דקה היא תקל על המצב ותרפא את העור",
                                    emotional:'ביישן וכנוע, קושי לעמוד על שלו',
                                    unique:'לסלק גופים זרים שחדרו פנימה'
                                    ,id:6
                                },
                                {
                                    remedyName:'Hep-sulph',
                                    physical:"פצע מוגלתי כתוצאה מחדירה של גוף זר. תחושת קור ורגישות גבוהה. כאבים חזקים, הפרשות צהובות, דמיות ומסריחות",
                                    emotional:'פגיע ורגיש מאוד, מגיב בצורה אלימה ומוגזמת לכל תחושה של איום',
                                    unique:'זיהום כתוצאה מחדירה של גוף זר'
                                    ,id:7
                                }
                                ],  
                                
                                
                                [
                                    {
                                        remedyName:'ACONITE',
                                        physical:'שוק רגשי פתאומי ועוצמתי, יוצר חוסר שקט רב, לא רוצה שיתקרבו אליו',
                                        emotional:'פחד גדול , חרדה, חוסר מנוחה. פחד בקהל, לא רוצה לצאת מהבית, חושב שהולך למות',
                                        unique:'אחרי שוק פתאומי – פציעה חזקה, תאונה, פיגוע, טראומה רגשית',
                                        id:1
                                    },
                                    {
                                        remedyName:'ARGENTUM NITRICUM',
                                        physical:'מלא פחדים ומחשבות שמשהו רע הולך לקרות',
                                        emotional:'עצבני, אימפולסיבי וחסר שקט',
                                        unique:'חרדה כתוצאה מציפייה',
                                        id:2
                                    },
                                    {
                                        remedyName:'ARSENICUM',
                                        physical:'תחושת חוסר ביטחון קיומי, הכל מסוכן ומאיים, לא רוצה אף אחד לידו, אבל גם לא רוצה להיות לבד',
                                        emotional:'חוסר שקט עצבני, היפוכונדר, חייב לסדר דברים במקום',
                                        unique:"התקף חרדה מלווה בקיבה עצבנית, דופק מואץ, קור וצמרמורות",
                                        id:3
                                    },
                                    {
                                        remedyName:'GELSEMIUM',
                                        physical:'חרדה ממבחנים, אירועים מיוחדים – מלווה בשלשולים או רעידות',
                                        emotional:'מרגיש שמאבד שליטה, חוסר כוח רצון להתמודד, רוצה שיעזבו אותו בשקט',
                                        unique:'חרדת ביצוע – קושי להתמודד עם מצבים  חדשים, רעד פנימי או חיצוני',
                                        id:4
                                    },
                                    {
                                        remedyName:'OPIUM',
                                        physical:'שוק רגשי המוביל למצב של התכנסות וחוסר תגובתיות',
                                        emotional:'הכל נכנס למן שיתוק וחוסר תגובתיות – מערכת עצבים איטית, קשיי ריכוז, שיפוט לקוי',
                                        unique:'חוסר תגובתיות, כניסה לעולם פנימי'
                                        ,id:5
                                    }
                                    ],
                                    [
                                        {
                                            remedyName:'ACONITE',
                                            physical:'הופעה פתאומית של כאב ראש חזק, חום גבוה, כאבי שרירים, התעטשויות תכופות ונזלת שקופה',
                                            emotional:'חוסר שקט בעיקר בלילה, לא מסוגל לישון',
                                            unique:'כתוצאה מקור יבש כמו מזגן או רוחות יבשות. הכל פתאומי, מהיר ועוצמתי. תחילת מחלת השפעת',
                                            id:1
                                        },
                                        {
                                            remedyName:'EUP-PER',
                                            physical:'חום גבוה, כאבים מאוד חזקים בעצמות ושרירים. חסר שקט, אבל כל תנועה כואבת ומחמירה את מצבו',
                                            emotional:'נואש, מותש וגונח',
                                            unique:'כאב ראש חזק בשיא החום, הראש כבד ונעזר בידיים בכדי להזיז אותו',
                                            id:2
                                        },
                                        {
                                            remedyName:'ARSENICUM',
                                            physical:'חוסר שקט פיזי חזק, תחושה של קור. תשישות. בחילות , הקאות ושלשולים. פנים חמות וגוף קר',
                                            emotional:'מאוד חסר שקט, חרדתי ולא רוצה להיות לבד, אבל נוכחות אנשים מעצבנת אותו',
                                            unique:"תחושת קור פנימי כה חזק שמרגיש כאילו שורף. צמא למשקאות חמים",
                                            id:3
                                        },
                                        {
                                            remedyName:'BRYONIA',
                                            physical:'כאבים קשים בגוף. לא רוצה לזוז, כל תנועה מחמירה. חם לו ומזיע המון.',
                                            emotional:'עצבני, רוצה לשכב ולא לזוז, שיעזבו אותו בשקט',
                                            unique:'תחושת יובש חזקה עם צמא גדול, מרגיש שהראש עומד להתפוצץ, לעיתים שיעול יבש.',
                                            id:4
                                        },
                                        {
                                            remedyName:'GELSEMIUM',
                                            physical:'תשישות וישנוניות, בקושי פותח עיניים. אין כוח להזיז את הגוף.',
                                            emotional:'חסר מצב רוח, מתוסכל, עייף',
                                            unique:'כבד ועייף, לא רוצה לשתות, זיעה דביקה'
                                            ,id:5
                                        },
                                        {
                                            remedyName:'NUX-V',
                                            physical:'רגישות חושית קיצונית – רעש, אור. מאוד עצבני. יש בחילה והתכווצויות בבטן.',
                                            emotional:'עצבני וחסר סבלנות, קר לו וחושש מפרצי רוח. דואג בענייני עבודה',
                                            unique:'תחושת קור, ענייני בטן(בחילות ויציאות מרובות). תחושת יובש אבל אין צמא'
                                            ,id:6
                                        }
                                        ],
                                        [
                                            {
                                                remedyName:'ARNICA',
                                                physical:'שימושי מידית אחרי מתיחה או נקע. מתיחה עם כאב עז. הרעה ממגע קל, תנועה.',
                                                emotional:'פחד שיגעו במקום הפגוע, " אני בסדר, הנח לי לנפשי"',
                                                unique:'אחרי פגיעה טראומטית, שימוש יתר באיבר, נקע ומתיחה.',
                                                id:1
                                            },
                                            {
                                                remedyName:'BELLIS PERENNIS',
                                                physical:'זו הרמדי הראשונה לפגיעה ברקמות עמוקות, נקע עם כאב עז',
                                                emotional:'חוסר שקט וצורך לזוז',
                                                unique:'תוצאה של פגיעות בעצבים, כאב עז',
                                                id:2
                                            },
                                            {
                                                remedyName:'BRYONIA',
                                                physical:'מפרק אדום, נפוח, עם עקצוצים וכאב קורע שמורע מתנועה. כל נקודה כואבת מלחץ. מועיל מאוד אחרי Arn כשהתנועה מוגבלת מאוד והנפיחות חריפה.',
                                                emotional:'לא רוצה שיגעו בו, כל תזוזה מעצבנת ומכעיסה אותו',
                                                unique:"נקעים שמוחרפים מתנועה קלה ביותר ומוטבים במנוחה מוחלטת",
                                                id:3
                                            },
                                            {
                                                remedyName:'CALCAREA CARB',
                                                physical:'נקעים ישנים שלא נרפאים, נטייה לנקעים חוזרים',
                                                emotional:'משתעמם בקלות. רוצה כל הזמן לעשות משהו',
                                                unique:'חולשה פיזית, עייפות וגמלוניות',
                                                id:4
                                            },
                                            {
                                                remedyName:'RHUS TOX',
                                                physical:'כאבים קורעים בגידים, ברצועות ובמיתרים. נוקשות המתפוגגת במהלך היום.',
                                                emotional:'חוסר שקט פנימי, פחדים ודאגות המוגברים בלילה',
                                                unique:'שימושי היכן שהמפרקים כואבים בתחילת תנועה ומוטבים מהמשך תנועה'
                                                ,id:5
                                            },
                                            {
                                                remedyName:'Hypericum',
                                                physical:'כאב עצבי חזק, דלקת בעצב. דקירות, כאבים שורפים, חוסר תחושה.',
                                                emotional:'תחושת בלבול, טעויות בכתיבה, מתענה מכאבים עצביים',
                                                unique:'שימושי בנקעים עם נזקים לעצבים'
                                                ,id:6
                                            },
                                            {
                                                remedyName:'RUTA',
                                                physical:'נזק לגידים, רצועות ומעטפת העצם. השפעה מיוחדת על שורש כף היד והקרסול.',
                                                emotional:'תחושת לאות, חולשה, עייפות וייאוש',
                                                unique:'פגיעות באזורי המפרקים'
                                                ,id:7
                                            }
                                            ]               
                                ]


                                export default AllRemedyInfo;